var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManageSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.409,
    height: 10.701,
    viewBox: "0 0 10.409 10.701",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Settiings",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-settings",
    "data-name": "Icon material-settings",
    d: "M10.6,7.125a4.169,4.169,0,0,0,.037-.524,4.169,4.169,0,0,0-.037-.524l1.129-.883a.27.27,0,0,0,.064-.342L10.723,3a.269.269,0,0,0-.326-.118l-1.332.535a3.909,3.909,0,0,0-.9-.524l-.2-1.418a.261.261,0,0,0-.262-.225H5.555a.261.261,0,0,0-.262.225l-.2,1.418a4.111,4.111,0,0,0-.9.524L2.853,2.882A.261.261,0,0,0,2.526,3L1.456,4.851a.264.264,0,0,0,.064.342l1.129.883a4.243,4.243,0,0,0-.037.524,4.243,4.243,0,0,0,.037.524L1.52,8.007a.27.27,0,0,0-.064.342L2.526,10.2a.269.269,0,0,0,.326.118l1.332-.535a3.909,3.909,0,0,0,.9.524l.2,1.418a.261.261,0,0,0,.262.225h2.14a.261.261,0,0,0,.262-.225l.2-1.418a4.111,4.111,0,0,0,.9-.524l1.332.535a.261.261,0,0,0,.326-.118l1.07-1.851a.27.27,0,0,0-.064-.342L10.6,7.125ZM6.625,8.473A1.873,1.873,0,1,1,8.5,6.6,1.875,1.875,0,0,1,6.625,8.473Z",
    transform: "translate(-1.42 -1.25)",
    fill: "#185cff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageSettings);
export default __webpack_public_path__ + "static/media/manage-settings.507b9fbd5f29ff844232a9f8a4fe6979.svg";
export { ForwardRef as ReactComponent };